// src/constants/index.js
import packageInfo from '../../package.json';

export const APP_NAME = 'KTC Framework';
export const APP_LOGO =
  'https://quraan.kaafiye.com/uploads/ktc_edit_sp/logo/logoquranuniversity.jpeg_ktceditsp_20240606070706.jpeg';

export const APP_VERSION = packageInfo.version;
export const currentDate = new Date();

export const COPYRIGHT_YEAR = currentDate.getFullYear();
export const CURRENT_YEAR = currentDate.getFullYear();
export const CURRENT_DATE = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;
export const FIRST_DAY_OF_MONTH = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-01`;

//console.log(dateOnly); // Output: "2024-12-16"
export const CURRENT_TIME = `${currentDate.getHours().toString().padStart(2, '0')}:${currentDate.getMinutes().toString().padStart(2, '0')}:${currentDate.getSeconds().toString().padStart(2, '0')}`;
//console.log(timeOnly); // Output: "14:53:28"

export const DEFAULT_LANGUAGE = 'en';
export const SUPPORTED_LANGUAGES = ['en', 'es', 'fr'];

export const escapeSingleQuotes = (str) => {
  const str2 = str.replace(/'/g, "\\'");
  console.log('str:', str, 'str2:', str2);
  return str2;
};
